module.exports = __webpack_public_path__ + "static/media/buildMyLogo.180d5a2e.svg";